import React, { FC } from "react";
import { Result } from "antd";
import { useIntl } from "react-intl";
import { useRouter } from "next/router";
import { AveliosButton } from "../common-layout/avelios-button";

export const Error: FC = () => {
  const { formatMessage } = useIntl();
  const router = useRouter();
  return (
    <Result
      status="warning"
      title={formatMessage({ id: "error.title" })}
      subTitle={formatMessage({ id: "error.message" })}
      extra={[
        <AveliosButton
          type="primary"
          key="console"
          onClick={() => router.push("/")}
        >
          {formatMessage({ id: "not-found.back-home" })}
        </AveliosButton>,
      ]}
    />
  );
};
